export default "__VITE_ASSET__DzQLrnAe__"